import React from 'react'
import { Link } from 'react-router-dom'

export const MenuItem = ({ imgSrc, description, linkTo }) => {
  return (
    <Link to={linkTo} className='group'>
      <div className='glass-card hover-glow rounded-3xl p-6 h-full flex flex-col items-center justify-center transition-all duration-300'>
        <div className='bg-amber-500/10 p-4 rounded-2xl mb-4 group-hover:scale-110 transition-transform'>
          <img src={imgSrc} alt='' className='h-16 lg:h-24 w-auto object-contain' />
        </div>
        <p className='text-sm lg:text-xl font-medium text-amber-50 tracking-wide text-center uppercase'>
          {description}
        </p>
      </div>
    </Link>
  )
}